import { apiWrapper } from "@/services/api";
import store from "@/store/index";

export const getPass = async (id, timeout = 60 * 1000) => {
  try {
    const resp = await apiWrapper(
      "GET",
      `passes/${id}`,
      null,
      false,
      null,
      null,
      timeout
    );
    console.log("getPass: >> ", resp.data);
    store.commit("ticketing/setPass", resp.data);
    return resp.data;
  } catch (err) {
    console.log("ERROR!!! getPass");
    throw err;
  }
};
